import { render, staticRenderFns } from "./KeepAwake.vue?vue&type=template&id=27611387&"
import script from "./KeepAwake.vue?vue&type=script&lang=ts&"
export * from "./KeepAwake.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports